import { Link, useLocation } from "react-router-dom";
import { Sparkles, AudioLines, Images, Plug, LogOut, Wand2, Music, Columns2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/", icon: Wand2, label: "Create", match: (p) => p === "/" },
  { to: "/compare", icon: Columns2, label: "Compare", match: (p) => p.startsWith("/compare") },
  { to: "/voice", icon: AudioLines, label: "Voice", match: (p) => p.startsWith("/voice") },
  { to: "/music", icon: Music, label: "Music", match: (p) => p.startsWith("/music") },
  { to: "/gallery", icon: Images, label: "Gallery", match: (p) => p.startsWith("/gallery") },
  { to: "/connections", icon: Plug, label: "Connections", match: (p) => p.startsWith("/connections") },
];

export default function LeftRail() {
  const { pathname } = useLocation();
  const { logout, user } = useAuth();
  return (
    <div className="w-16 shrink-0 border-r border-zinc-800 bg-[#0d0d0d] flex flex-col items-center py-3 gap-1" data-testid="left-rail">
      <div className="h-9 w-9 rounded-md bg-[#faff69] grid place-items-center mb-3">
        <Sparkles className="h-5 w-5 text-black" />
      </div>
      {ITEMS.map((it) => {
        const active = it.match(pathname);
        const Icon = it.icon;
        return (
          <Link key={it.to} to={it.to} data-testid={`rail-${it.label.toLowerCase()}`}
            className={`group relative w-12 h-12 rounded-lg grid place-items-center transition-colors ${active ? "bg-[#faff69]/10 text-[#faff69]" : "text-zinc-500 hover:text-white hover:bg-zinc-800/60"}`}>
            {active && <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-0.5 bg-[#faff69] rounded-r" />}
            <Icon className="h-5 w-5" />
            <span className="absolute left-full ml-2 px-2 py-1 rounded bg-zinc-800 text-white text-[11px] whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50">{it.label}</span>
          </Link>
        );
      })}
      <div className="mt-auto flex flex-col items-center gap-2">
        <div className="h-8 w-8 rounded-full bg-zinc-800 grid place-items-center text-[11px] font-semibold text-zinc-300 uppercase" title={user?.email}>
          {(user?.name || user?.email || "?").slice(0, 1)}
        </div>
        <button onClick={logout} data-testid="rail-logout" className="w-10 h-10 rounded-lg grid place-items-center text-zinc-500 hover:text-[#FF3B30] hover:bg-zinc-800/60 transition-colors">
          <LogOut className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
